
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz, ImagenMasivo } from '../../controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Estado() { return this.Controlador.Vista.Estado; }

        public SeleccionarArchivo: boolean = true;

        public async AgregarArchivo( archivo: File | File[] )
        {
            if ( !archivo )
                return;
            if ( archivo instanceof File )
            {

                console.log( archivo.name );
            } else
            {
                for ( let arch of archivo )
                {
                    let a = new ImagenMasivo();
                    a.Codigo = arch.name.substring( 0, 7 ).formatearCodigoArticulo();
                    a.Nombre = arch.name;
                    a.Imagen = arch;
                    this.Controlador.Imagenes.push(a)
                }
            }


            //this.Cargando = true;
            //await Wait( 1000 );
            //let ar = await this.Articulo.SubirImagen( archivo );
            //if ( ar )
            //{
            //    this.Iniciar();
            //} else
            //{
            //    this.$EventBus.Notificaciones.Error( 'Error al subir el archivo' );
            //}


            //this.Cargando = false;
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
